// @flow strict
import * as React from "react"

import { modals } from "../../../../utils/nitroSideEffects"

type Props = {|
  modal: string,
|}

export default class Core extends React.PureComponent<Props> {
  componentDidUpdate() {
    const { modal } = this.props

    // $FlowExpected: Not using specifics on purpose here
    modals(modal)
  }

  // eslint-disable-next-line lodash-fp/prefer-constant
  render() {
    return null
  }
}
